import { Button, message } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { apiCall } from "../utils/Api";
import ReCAPTCHA from "react-google-recaptcha";
import { useSession } from "../utils/Session";

export default function CopyButton(props) {

    const { label = "Copy", copy_text = "TODO", error_text = "Can't copy", success_text = "Copied!", block = true, buttonProps = {}, request = false, eisbn } = props;



    const [session, setSession] = useSession();
    const [copied, setCopied] = useState(false);
    const [showCaptcha, setShowCaptcha] = useState(false);
    const [captcha, setCaptcha] = useState(null);
    const recaptchaRef = useRef(null);

    const fetchISBN = (captchaToken) => {

        apiCall("title/getProductCode", { eisbn: eisbn, captcha: captchaToken }, (_s, _r) => {
            if (_s) {
                copyText(_r?.isbn);
            } else {
                message.error(_r.error);
            }
            setShowCaptcha(false);
        });
    }


    const copyText = (copy_text) => {
        if (!navigator.clipboard) {
            message.error(error_text);
            return;
        }
        navigator.clipboard.writeText(copy_text);
        setCopied(true);
        setTimeout(() => {
            setCopied(false)
        }, 1000);
    }

    const copyToClipboard = (e) => {


        if (request) {

            if (!(session?.has_bm_data_lite || session?.has_bm_data_full)) {

                if (session?.logged_in) {
                    fetchISBN("");
                } else {
                    setShowCaptcha(true);
                }

            }

            copyText(copy_text);

            return;
        }

    }


    useEffect(() => {
        if (showCaptcha && recaptchaRef.current) {
            recaptchaRef.current.execute();
        }
    }, [showCaptcha]);


    return (
        <>
            <Button {...buttonProps} block={block} type={(copied ? "primary" : "default")} onClick={() => copyToClipboard()} >{(copied) ? success_text : label}</Button>
            {showCaptcha && (
                <ReCAPTCHA
                    ref={recaptchaRef}
                    size="invisible"
                    sitekey={"6LfPBUslAAAAAIrLp814HpBIixMj0rL5J3cAxEUw"}
                    onChange={(token) => {
                        setCaptcha(token);
                        fetchISBN(token);
                    }}
                />
            )}

        </>
    )


}